import Wrap from '@/views/Wrap'
import Main from '@/views/client/Main'
import Index from '@/views/client/index'
import Order from '@/views/client/order'
import Pay from '@/views/client/pay'

export default {
    path: "/client",
    name: "平台",
    component: Wrap,
    redirect: "client/main",
    meta: { hideInBreadcrumb: true },
    children: [
        {
            path: 'main',
            name: '首页',
            component: Main,
            redirect: 'main/index',
            children: [
                {
                    name: '主页',
                    path: 'index',
                    meta: { hideBreadcrumb: true },
                    component: Index
                },
                {
                    name: '订单',
                    path: 'order',
                    meta: { hideBreadcrumb: true },
                    component: Order
                },
                {
                    name: '支付',
                    path: 'pay/:orderId/:paymentId',
                    meta: { hideBreadcrumb: true },
                    component: Pay
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/client/index.js